export const GIT_FALLBACK_DATA = {
    "three.js-personal-website": {
        total_commits: 101,
        latest_commits: {
            commits: [
                { message: "Started rough layout of git activity card", timeAgo: "6 days ago" },
                { message: "Refactored Radio Header at Project Warehouse", timeAgo: "8 days ago" },
                { message: "Merge pull request #6 from...", timeAgo: "9 days ago" }
            ]
        },
        language_percentages: {
            "JavaScript": "88.71",
            "CSS": "11.18", 
            "HTML": "0.11"
        },
        commits_per_week: {
            commitsPerWeek: [2, 1, 4, 5, 2, 3, 6, 4, 3, 7, 5, 8, 6, 4, 9, 7, 5, 6, 8, 4, 3, 5, 7, 6, 4, 8, 9, 5, 6, 7]
        }
    },
    "Creole-Linguistics-Data-Analytics": {
        total_commits: 7,
        latest_commits: {
            commits: [
                { message: "Added New Lyrics Data and Cleaned Up Code", timeAgo: "2 years ago" },
                { message: "Added English Dictionary Data", timeAgo: "2 years ago" },
                { message: "Completed Data Cleaning and Improved Accuracy", timeAgo: "2 years ago" }
            ]
        },
        language_percentages: {
            "R": "65.2",
            "Python": "25.8",
            "JavaScript": "9.0"
        },
        commits_per_week: {
            commitsPerWeek: [5, 2, 5, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
    },
    "chess-analysis-server": {
        total_commits: 1,
        latest_commits: {
            commits: [
                { message: "Maybe a commit", timeAgo: "1 week ago" },
                { message: "Tested Chess Analysis", timeAgo: "2 weeks ago" },
                { message: "Initial Commit", timeAgo: "3 weeks ago" }
            ]
        },
        language_percentages: {
            "Python": "100.0",
        },
        commits_per_week: {
            commitsPerWeek: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
    }
};

export default GIT_FALLBACK_DATA; 